module.exports = __webpack_public_path__ + "static/img/djhs.a3ad9724.jpg";